import styled from 'styled-components';
import { Icon } from '../../../core/components';

export const NavigationBarIcon = styled(Icon)`
  width: 32px;
  height: 32px;
  margin-right: 10px;
`;
